module.exports = __webpack_public_path__ + "static/img/help.bd01b01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help.jpg
// module id = 1368
// module chunks = 0